module.exports = __webpack_public_path__ + "static/img/renwutongbu.289df1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/renwutongbu.png
// module id = IO6u
// module chunks = 24